import type AppConfig from 'aem-libs-react-ts/src/types/app-config'
import { isDefined } from 'aem-libs-ts/src/utils/common/isDefined'

import { HttpClient } from '../../../utility/HttpClient'
import type {
  BuildingSavingsModellingRequest,
  BuildingSavingsModellingResponse,
  CalculateLoanRequest,
  CalculateLoanResponse,
  ExtraordinaryInstallmentFeeQuery,
  ExtraordinaryInstallmentFeeResponse
} from './types'

export const buildingSavingsProductService = ({ webApi }: AppConfig) => {
  const apiBase = 'v1/building-savings-product'

  const httpClient = new HttpClient(webApi, apiBase)

  return {
    buildingSavingsModelling: (payload: BuildingSavingsModellingRequest) => {
      return httpClient.post<BuildingSavingsModellingResponse>('/bs-modelling', { payload })
    },
    calculateLoan: (payload: CalculateLoanRequest) => {
      const queryParams = new URLSearchParams({
        productId: payload.productId.toString(),
        loanAmount: payload.loanAmount.toString(),
        installmentCount: payload.installmentCount.toString(),
        rating: payload.rating.toString()
      })

      if (payload.insuranceType) {
        queryParams.append('insuranceType', payload.insuranceType.toString())
      }

      if (payload.fixation) {
        queryParams.append('fixation', payload.fixation.toString())
      }

      return httpClient.get<CalculateLoanResponse>(`/calculate-loan?${queryParams.toString()}`)
    },
    extraordinaryInstallmentFee: (payload: ExtraordinaryInstallmentFeeQuery) => {
      const queryPathParams = new URLSearchParams(
        Object.entries(payload)
          .filter(([, value]) => isDefined(value))
          .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {})
      ).toString()
      return httpClient.get<ExtraordinaryInstallmentFeeResponse>(
        `/${payload.accnr}/extraordinaryinstallmentfee?${queryPathParams}`
      )
    }
  }
}
